// client/src/components/dashboard/ProgressTracking.tsx

import React, { useState, useEffect } from "react";
import "../../assets/styles/dashboard.css";
import progressService from "../../services/progressService";

// Define the expected type of progress data. You could also import this from your types file.
interface SubjectProgress {
  subject: string;
  progress: number;
}

const ProgressTracking: React.FC = () => {
  const [progressData, setProgressData] = useState<SubjectProgress[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  // Fetch data from the backend when the component mounts.
  useEffect(() => {
    const fetchProgressData = async () => {
      try {
        const data = await progressService.getProgressData();
        setProgressData(data);
      } catch (err: any) {
        setError(err.message || "Failed to fetch progress data.");
      } finally {
        setLoading(false);
      }
    };

    fetchProgressData();
  }, []);

  if (loading) {
    return <p>Loading progress data...</p>;
  }

  if (error) {
    return <p style={{ color: "red" }}>{error}</p>;
  }

  return (
    <div className="progress-tracking">
      <h2>Progress Tracking</h2>
      {progressData.length === 0 ? (
        <p>No progress data available at the moment.</p>
      ) : (
        progressData.map(({ subject, progress }) => (
          <div key={subject} className="progress-item">
            <div className="progress-label">
              {subject} - {progress}%
            </div>
            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default ProgressTracking;
